import React from "react";
import HubblePageContainer from "./components/HubblePageContainer";
import CompressEducationSlider from "./components/CompressEducationSlider";
import { useNavigate } from "react-router";

import { FaArrowLeftLong } from "react-icons/fa6";
import HuubleCard from "./components/HuubleCard";
import HubbleButton from "./components/HubbleButton";

const CompressEducation = () => {
  const navigate = useNavigate();
  return (
    <HubblePageContainer>
      <div className="d-flex justify-content-between align-items-center py-2">
        <h4>آموزش فشرده سازی</h4>
        <div onClick={() => navigate(-1)}>
          <FaArrowLeftLong size={20} />
        </div>
      </div>
      <div className="mt-4">
        <CompressEducationSlider />
      </div>
      <div className="my-4">
        <HuubleCard>
          <p style={{ fontSize: "14px" }}>
            🌻آموزش استفاده از نرم افزار کاهش حجم فیلم🌻
            <br />
            <br />
            🦋مرحله اول: گزینه داخل دایره سبز رنگ را انتخاب نمایید
            <br />
            <br />
            🦋مرحله دوم: 1-نرم افزار به صورت خودکار پیشنهاد کاهش حجم میدهد اگر
            عدد داخل مستطیل زرد رنگ زیر 200مگ را نشان میداد فقط کافیست گزینه
            داخل دایره سبز را انتخاب کنید و وارد تصویر مرحله چهارم شوید 2- اگر
            عدد داخل مستطیل زرد رنگ بیشتر از 200 مگ را نشان میداد گزینه مستطیل
            بنفش را انتخاب کنید و وارد تصویر مرحله سوم بشوید
            <br />
            <br />
            🦋مرحله سوم:(در صورت نیاز) در این مرحله میتوانید با تغییر کیفیت حجم
            فایل را کاهش بدهید مقابل هر کدام از گزینه های کیفیت فیلم حجم آن را
            هم نوشته است هر کدام که زیر 200 مگ بود را نتخاب نمایید و گزینه داخل
            دایره سبز رنگ در تصویر مرحله دوم را انتخاب کنید
            <br />
            <br />
            🦋مرحله چهارم: در این مرحله نرم افزار در حال آماده سازی فیلم با
            اندازه مورد نظر می باشد و باید منتظر بمانید
            <br />
            <br />
            🦋مرحله پنجم: در این مرحله فیلم آماده شده و با فشردن گزینه مستطیل
            سبز فیلم در گالری گوشی شما ذخیره میگردد و میتوانید برای چالش جفت پوچ
            استفاده نمایید
          </p>
        </HuubleCard>
      </div>
      <HubbleButton
        onClick={() =>
          window.open(
            "http://dl.rahebehesht.com/VidCompact.Pro_3.0.1_Android.apk",
            "_blank"
          )
        }
      >
        دانلود نرم افزار
      </HubbleButton>
    </HubblePageContainer>
  );
};

export default CompressEducation;
